"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Location {
}
exports.Location = Location;
//# sourceMappingURL=Location.js.map